/*
 * @Description:
 */

import { ContentType, Device } from '@/constant/headers'
import { InfoShowType } from '@/constant/network'
import settings from "./setting.config";
interface Headers{
    Authorization: string
    contentType: string
    version: string
    device: Device
}

const _header: Headers = {
  Authorization: '',
  contentType: ContentType.JSON,
  version: settings.version ?? '1.0',
  device: Device.PC
}

export interface NetworkConfig{
    host?: string
    eureka?: string
    monitor?: string
    elk?: string
    deuid?: string
    timeout?: number
    loading?: false
    errorShowType?: InfoShowType
    header?: {}
}

const networkConfig: NetworkConfig = {
  host: process.env.VUE_APP_BASE_API,
  eureka: process.env.VUE_APP_EUREKA_API,
  monitor: process.env.VUE_APP_MONITOR_API,
  timeout: 10000,
  loading: false,
  errorShowType: InfoShowType.LOG,
  header: _header
}

export default networkConfig
